module.exports = __webpack_public_path__ + "img/柚子1.45c09da6.png";